export default __webpack_public_path__ + "static/login-3eaf8007460931c8becdfce2b3320686.png";